import { TableHeadItemRecurse } from '../../components/TableHead';

export const customersTableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2.5, orderValue: 'name' },
  { title: 'CPF/CNPJ', flex: 1.2, orderValue: 'cpfCnpj' },
  { title: 'Conta de custódia' },
  { title: 'Saldo Disponível', flex: 1.4 },
  { title: 'IR' },
  { title: 'Cadastro', orderValue: 'registrationStatus' },
  { title: '', flex: 0.3 },
];
